export function getStripeFinancialOperationsUnavailableMessage(
  helloEmailAddress: string
): string {
  return `Payments purchases and refunds are temporarily unavailable. This will be restored as soon as possible. For urgent help, contact us at ${helloEmailAddress}.`;
}

export function getMedicalQuestionnaireDeferCompletionMessage(
  helloEmailAddress: string
): string {
  return `We can't complete your medical questionnaire right now because of system maintenance. Please return at a later time to finish. For urgent help, contact us at ${helloEmailAddress}.`;
}
